import { render } from "./Query.vue?vue&type=template&id=cda1fba8&scoped=true"
import script from "./Query.vue?vue&type=script&lang=js"
export * from "./Query.vue?vue&type=script&lang=js"

import "./Query.vue?vue&type=style&index=0&id=cda1fba8&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda1fba8"]])

export default __exports__